import axiosInstance from '../axiosInterceptor/axiosInstance'

// Point a game's scoreboard overlay at a different input. Safe to call while the stream is
// running: the backend persists the choice, tells the sidecar which input to forward over Redis
// and, for a live stream, patches the pod — no restart, so the board changes on air.
// Owners and admins may call it, as may the game's assigned studio operator.
const setScoreboardSource = (orgId, gameId, scoreboardSource) =>
  axiosInstance
    .patch(`v1/orgs/${orgId}/games/${gameId}/scoreboard-source`, { scoreboardSource })
    .then((r) => r.data)

export default setScoreboardSource
